import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setMembers: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.total = payload.total;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.loading = !!payload.loading;
};

// 详情
export const setMemberDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 会员类型
export const setMemberTypes: Mutation<IModuleState> = (state, payload) => {
  state.types.data = payload.data;
  state.types.raw = payload.data;
  state.types.loading = !!payload.loading;
};

// 组织类型
export const setOrgTypes: Mutation<IModuleState> = (state, payload) => {
  state.orgTypes.data = payload.data;
  state.orgTypes.raw = payload.data;
  state.orgTypes.loading = !!payload.loading;
};

// 检测结果
export const setCheckResult: Mutation<IModuleState> = (state, payload) => {
  state.checkResult.exist = payload.success;
  state.checkResult.loading = payload.loading;
};

// 密码重置日志
export const setResetLogs: Mutation<IModuleState> = (state, payload) => {
  state.resetLogs.data = payload.data;
  state.resetLogs.loading = payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title || '';
  state.confirm.content = payload.content || '';
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
